interface PhonePayload {
  mobileNumber: string;
  name: string;
}

export default function shouldFireOnFocusBPTab(
  isFocused: boolean,
  setBPPhone: (payload: PhonePayload) => void,
  mobileNumber: string,
  userName: string,
): void {
  if (isFocused) {
    setBPPhone({ mobileNumber, name: userName });
  }
}
